import { Model, Attr, HasOne } from 'spraypaint';
import { NullProxy, RecordProxy } from 'spraypaint/lib-esm/proxies';
import ApplicationRecord from 'spa-ionata-admin/lib/models/ApplicationRecord';
import LocaleItem from '../services/LocaleItem';
import User from './User';

export type ExportMarketProxy =
  | RecordProxy<ExportMarket>
  | NullProxy<ExportMarket>;

@Model()
export default class ExportMarket extends ApplicationRecord {
  static jsonapiType = 'export-markets';

  // --- Attributes
  // --------------

  // required
  // unique
  // maxLength: 2
  @Attr() shortCode!: string;

  // required
  @Attr() title!: TranslatableText;

  // nullable -- that means it is false
  @Attr() visible!: boolean;

  // readOnly
  @Attr() createdAt!: string | null;

  // readOnly
  @Attr() modifiedAt!: string | null;

  // --- Relationships
  // -----------------

  // @HasMany() businesses!: (Business | DraftBusiness)[];

  // nullable
  @HasOne() createdBy!: User | null;

  // nullable
  @HasOne() modifiedBy!: User | null;

  // --- Custom
  // ----------

  constructor(attrs?: HashAny) {
    super(attrs);

    this.locale = new LocaleItem(this, {
      keys: ['title'],
    }).asHash();
    // CHECK: Is locale creating a strong reference to this? Do we need to free it?
  }

  locale: Hash<string | undefined>;
}
